import { BarChart2, Clock, ClockPlus, Lock, Timer, Upload } from 'lucide-angular';
import { MenuAction } from '@shared/interfaces/header/menu-action';

export function getMeteringPointTimeSeriesActionMenu(machineLearningEnabled: boolean, showGraph: boolean = false): MenuAction[] {
  return [
    {
      id: 'request',
      title: 'meteringpoint.timeseries.request.title',
      icon: Timer
    },
    {
      id: 'manual',
      title: 'meteringpoint.timeseries.manualsubmit.title',
      icon: Clock
    },
    ...(machineLearningEnabled ? [{
      id: 'advanced',
      title: 'meteringpoint.timeseries.advancedsubmit.title',
      icon: ClockPlus
    }] : []),
    {
      id: 'lock',
      title: 'meteringpoint.timeseries.locktimeseries.title',
      icon: Lock
    },
    {
      id: 'upload',
      title: 'meteringpoint.csvupload.title',
      icon: Upload
    },
    {
      id: 'toggleGraph',
      title: showGraph ? 'meteringpoint.timeseries.graph.hide' : 'meteringpoint.timeseries.graph.show',
      icon: BarChart2,
      breaker: true,
    },
  ];
}
